import type { StepConfig } from '../../types/workflow';

const AddPrivateNote: StepConfig = {
  // Design
  icon: 'privateNote',
  headerTextColor: '#8625BE',
  headerColor: '#E4D9F1',
  title: 'Private Note',
  text: 'Add a Private Note',
  category: 'Node',
  desc: 'Add a private note to the contact. This note will not be visible to the contact.',
  primaryKey: 'content',
  formFields: [
    {
      key: 'content',
      label: 'Comment',
      type: 'textarea',
      defaultValue: '',
      placeholder: 'Enter your comment here...',
      validation: {
        required: true,
      },
    },
  ],
};

export default AddPrivateNote;
